import { Users, Activity, Home, HeartPulse, Scale, Newspaper, Sprout, MonitorSmartphone } from "lucide-react";

export const SKILLS = [
  { name: "Mixed-Methods Evaluation Design", pct: 98 },
  { name: "Outcome Harvesting & Change Mapping", pct: 97 },
  { name: "MEL Systems Architecture & Design", pct: 96 },
  { name: "Contribution Analysis & Attribution", pct: 95 },
  { name: "Theory of Change Development", pct: 95 },
  { name: "Strategic Learning & Knowledge Management", pct: 93 },
  { name: "Data Quality Assurance (DQA)", pct: 94 },
  { name: "Value for Money (VfM) Analysis", pct: 90 },
];

export const METHODOLOGIES = [
  ["Outcome Harvesting", "green"], ["Contribution Analysis", "blue"], ["Most Significant Change", "purple"],
  ["Difference-in-Differences", "gold"], ["Participatory Action Research", "green"], ["Outcome Mapping", "blue"],
  ["Qualitative Comparative Analysis", "purple"], ["Theory-Based Evaluation", "gold"], ["OECD-DAC Criteria", "green"],
  ["Systematic Review", "blue"], ["Realist Evaluation", "purple"], ["GESI-Responsive Methods", "gold"],
];

export const TOOLS = [
  ["Kobo Toolbox", "blue"], ["ODK", "green"], ["NVivo", "purple"], ["ATLAS.ti", "gold"],
  ["SPSS", "blue"], ["Tableau", "green"], ["Airtable", "purple"], ["MS Excel (Advanced)", "gold"],
  ["Power BI", "blue"], ["R", "green"],
];

export const RADAR_DATA = [
  { subject: "Humanitarian", value: 97 },
  { subject: "Education & Literacy", value: 91 },
  { subject: "Health & Nutrition", value: 88 },
  { subject: "Governance & Civic", value: 93 },
  { subject: "Media & Digital", value: 89 },
  { subject: "Food Security & FSL", value: 85 },
  { subject: "Peacebuilding", value: 87 },
  { subject: "Private Sector", value: 78 },
];

export const SECTORS = [
  { icon: Activity, name: "Humanitarian Response", sub: "NE Nigeria, Syria corridors, fragile states" },
  { icon: Home, name: "Education & Literacy", sub: "EGRA/EGMA, TVET, education governance" },
  { icon: HeartPulse, name: "Health & Nutrition", sub: "PHC, RMNCAH, CMAM, GBV/protection" },
  { icon: Scale, name: "Governance & Civic Space", sub: "Civil society, digital rights, academic freedom" },
  { icon: Newspaper, name: "Media & Digital Innovation", sub: "Media development, digital security, HRDs" },
  { icon: Sprout, name: "Food Security & Livelihoods", sub: "FSL, WASH, resilience, cash transfers" },
  { icon: Users, name: "Peacebuilding & Stabilisation", sub: "PCVE, DDR, social cohesion, Lake Chad Basin" },
  { icon: MonitorSmartphone, name: "Private Sector & Enterprise", sub: "Agri-SMEs, TVET, economic empowerment" },
];
